/**
 * Header モジュール（ハンバーガー / スクロール判定）
 * - Header.astro のインラインスクリプトを modules 化
 */
export default class Header {
  constructor(options = {}) {
    if (window.__HEADER_MODULE_INITIALIZED__) return;
    window.__HEADER_MODULE_INITIALIZED__ = true;

    // JS 初期化完了フラグ（CSS の初回トランジションを抑制 → 初期化後に有効化するためのクラス）
    if (typeof document !== 'undefined' && document.body) document.body.classList.add('is-js');

    this.MOBILE_BREAKPOINT = options.MOBILE_BREAKPOINT || 750;
    this.init();
  }

  debounce(fn, wait = 150) {
    let t = null;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  init() {
    this.setupHamburger();
    this.setupScrollHeader();
  }

  setupHamburger() {
    const menuBtn = document.querySelector('.l-header__menu-btn');
    const header = document.querySelector('.l-header');
    const nav = document.querySelector('.l-header__nav');
    if (!menuBtn || !header) return;

    // 初期 aria 状態を同期
    menuBtn.setAttribute('aria-expanded', header.classList.contains('is-open') ? 'true' : 'false');

    // スクロールロック制御
    let _lockedScrollY = 0;
    const lockScroll = () => {
      _lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${_lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.classList.add('is-scroll-locked');
    };
    const unlockScroll = () => {
      document.body.classList.remove('is-scroll-locked');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, _lockedScrollY || 0);
      _lockedScrollY = 0;
    };

    const closeHamburger = (focusBtn = false) => {
      header.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
      unlockScroll();
      if (focusBtn) menuBtn.focus();
    };

    const openHamburger = () => {
      header.classList.add('is-open');
      menuBtn.setAttribute('aria-expanded', 'true');
      lockScroll();
    };

    menuBtn.addEventListener('click', () => {
      if (header.classList.contains('is-open')) {
        closeHamburger(true);
      } else {
        openHamburger();
      }
    });

    // SP: ナビのリンクをタップしたらメニューを閉じる
    if (nav) {
      nav.addEventListener('click', (e) => {
        const target = e.target;
        const link = target && target.closest ? target.closest('a') : null;
        if (!link) return;

        // メガメニューのトリガーなら何もしない
        if (link.matches && link.matches('[data-mega-trigger]')) return;

        if (window.innerWidth <= this.MOBILE_BREAKPOINT) closeHamburger();
      });
    }

    // Esc で閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && header.classList.contains('is-open')) {
        closeHamburger(true);
      }
    });

    // ヘッダー外クリックで閉じる（開いているときのみ）
    document.addEventListener('click', (e) => {
      if (!header.classList.contains('is-open')) return;
      if (e.target.closest('.l-header')) return;
      closeHamburger();
    });

    // リサイズでデスクトップに戻ったら確実に閉じる
    window.addEventListener('resize', this.debounce(() => {
      if (window.innerWidth > this.MOBILE_BREAKPOINT && header.classList.contains('is-open')) {
        closeHamburger();
      }
    }, 150));
  }

  setupScrollHeader() {
    const header = document.querySelector('.l-header');
    if (!header) return;
    if (header.classList.contains('l-header--sub')) return;

    let ticking = false;
    const scrollThreshold = 100;

    const updateHeader = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      if (scrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });

    // 初期状態チェック
    updateHeader();
  }
}
